const isSupported = () => {
  if (!('localStorage' in window)) {
    return false;
  }

  try {
    const key = Math.random() + '';
    const value = 'verify local storage is available';
    localStorage.setItem(key, value);

    const content = localStorage.getItem(key);
    localStorage.removeItem(key);

    return content === value;
  } catch {
    return false;
  }
};

const nullHandler = () => {
  /* do nothing */
};

const localStorageFallback = {
  isSupported,
  set: nullHandler,
  has: () => false,
  getText: () => null,
  remove: nullHandler,
};

const localStorageAdaptor = {
  isSupported,
  set: (key: string, text: string) => localStorage.setItem(key, text),
  has: (key: string) => key in localStorage,
  getText: (key: string) => localStorage.getItem(key),
  remove: (key: string) => localStorage.removeItem(key),
};

export default isSupported() ? localStorageAdaptor : localStorageFallback;
